<template>
  <div>
    <!-- 头部视频 -->
    <div v-if="PromotionalVideo.name" class="header">
      <!-- 小程序环境隐藏返回导航 -->
      <go-back v-show="showBack && !checkFromMiniprogram" @goBack="goBack"></go-back>
      <span v-show="showBack && !checkFromMiniprogram" class="gobackBtn" @click="goBack">
        <img alt src="@/assets/images/icon/back1.png"/>
      </span>
      <div v-lazy:background-image="PromotionalVideo.imgUrl" class="head">
        <div v-if="!playStatus" class="head_btn">
          <img :src="foodPlay" @click="getDoctorDetail(PromotionalVideo)"/>
        </div>
      </div>

      <p>
        {{ PromotionalVideo.introduce }}
      </p>
    </div>
    <!-- 小程序环境隐藏无视频时的返回导航 -->
    <template v-else-if="!checkFromMiniprogram">
      <go-back v-show="showBack" @goBack="goBack"></go-back>
      <span v-show="showBack" class="gobackBtn" @click="goBack">
        <img alt src="@/assets/images/icon/back1.png"/>
      </span>
    </template>
    <!--isShowComment参数  小程序环境隐藏评论区，传值控制子组件显隐 -->
    <foodVedio
        ref="childVideo"
        :showVedio="showVedio"
        :userInfo="userInfo"
        :videoDetail="dataInfo"
        :videoId="dataInfo.id"
        isHfindex="true"
        :isShowComment="checkFromMiniprogram"
        @hideVedio="hidevedioEvent"
        @isUserLogin="isUserLogin"
        @playerBuriedpoint="playerBuriedpoint"
        @switchoverVideoNext="switchoverVideoNext"
        @switchoverVideoPrev="switchoverVideoPrev"
    />
    <!-- 专家介绍 -->
    <div class="expertIntroduction">
      <!-- 专家介绍 -->
      <div>
        <!-- 专家介绍标题 -->
        <div class="expertTitle">
          <img
              alt=""
              src="./../../../assets/images/activity/harvard/tit1.png"
          />
          <p>专家介绍</p>
          <img
              alt=""
              src="./../../../assets/images/activity/harvard/tit2.png"
          />
        </div>
      </div>
      <!-- 医生轮播 -->
      <div class="expert_swiper_container">
        <mySwiper
            :autoplay="false"
            :centeredSlides="true"
            :list="bjDoctorData.expertList"
            :loop="false"
            :paginationFlag="false"
            :slidesNum="0"
            :spaceBetweenNum="5"
            :swipeid="'bj_doctor_swiper'"
            style="overflow: hidden"
            @slideChange="slideChange"
        >
          <div
              v-for="(item, index) in bjDoctorData.expertList"
              :key="index"
              slot="swiper-con"
              class="swiper-slide"
              @click="doctorDetail(item)"
          >
            <div>
              <img :src="item.imgUrl" alt="" class="doctor_image"/>
            </div>

            <div class="swiper-content">
              <div class="swiper-content-right">
                <span>{{ item.name }}</span>
                <div>
                  <span>&nbsp;{{ item.hospital }}</span>
                  <!-- <span>&nbsp;{{ item.post }}</span> -->
                </div>
                <p>
                  {{ item.info }}
                </p>
              </div>
            </div>
          </div>
        </mySwiper>
      </div>
    </div>
    <!-- 列表数据 -->
    <div class="content-list expertIntroduction">
      <!-- 专家介绍 -->
      <div>
        <!-- 专家介绍标题 -->
        <div class="expertTitle">
          <img
              alt=""
              src="./../../../assets/images/activity/harvard/tit1.png"
          />
          <p>专题课程</p>
          <img
              alt=""
              src="./../../../assets/images/activity/harvard/tit2.png"
          />
        </div>
      </div>
      <!-- 列表数据 -->
      <!-- <div class="content-big">
        <p>
          <span class="dian"></span>
          <span>新生儿护理篇</span>
        </p>
      </div> -->
      <van-list
          v-model="pageParams.loading"
          :finished="pageParams.finished"
          :finished-text="bottomText"
          class="vant-list"
          error-text="请求失败，点击重新加载"
          load="getDoctorList"
      >
        <!-- 选择月龄 -->
        <div v-if="dataList" class="monthsc-hoose">
          <div id="select" class="selector" @click="showHander">
            <div class="selector-item">
              <span>{{ select }}</span>
              <img src="@/assets/images/baby/3.jpg"/>
            </div>
          </div>
          <!-- 选项 -->
          <div class="selector-down">
            <div class="triangle"></div>
            <div class="selector-option">
              <ul class="option">
                <li
                    v-for="(item, index) in optionList"
                    :key="item.id"
                    v-bind:class="{ active: active == index }"
                    @click.stop="seletHander(item.name, item.id)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <!-- 滚动标签 -->
          <van-tabs
              v-model="classificationActive"
              class="scroll-label"
              swipe-threshold="4"
              @click="onClickTab"
          >
            <van-tab
                v-for="(item, index) in categoryLabels"
                :key="index"
                :title="item.name"
            >
            </van-tab>
          </van-tabs>
        </div>

        <!-- 列表数据 -->
        <div class="content-big">
          <div
              v-for="(item, index) in dataList"
              :key="index"
              class="doctor-info"
              @click="jumpBjdoctor(item)"
              :data="JSON.stringify({name: item.name})"
          >
            <div v-lazy:background-image="item.coverUrl" class="info-img">
              <img :src="foodPlay" alt=""/>
              <!-- <div v-if="item[Masterrule[getmotherState().code]]">积分兑换</div> -->
              <div v-if="item.tag">{{ item.tag }}</div>
            </div>
            <!-- <img alt="" v-lazy="item[ind].imgUrl" /> -->
            <div class="doctor-info-right">
              <p>{{ item.name }}</p>
              <!-- <p class="over-text">
                {{ item.introduce }}
              </p> -->
              <div>
                <span class="bottomItem"
                ><img
                    class="icon"
                    src="./../../../assets/images/food/browse.png"
                /><span>{{ fomatterNum(item.watchNum) || 0 }}</span></span
                >
                <!-- <div>
                  <span @click.stop="doctorShare(item, 'baby')">分享</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="canvasposter" @touchmove.prevent @mousewheel.prevent>
          <div class="share_box">
            <img
                :src="src"
                alt=""
                class="share-image"
                @touchend="posterSaveEnd($event)"
                @touchstart="posterSaveStart($event)"
            />
            <canvasPoster
                :painting="painting"
                class="poster"
                @fail="fail"
                @success="success"
            >
            </canvasPoster>
          </div>
        </div>
      </van-list>
    </div>
    <!-- <login-tip
      :show="checkLogin"
      @confirmWay="confirmWay"
      @cancleWay="cancleWay"
    ></login-tip> -->
    <login-tip
        v-show="checkLogin" :bgStatus="2" @goLogin="confirmWay" @sendStatus="cancleWay"
    ></login-tip>
  </div>
</template>

<script>
import canvasPoster from "@/components/poster/doctor-canvas-poster.vue"; //疫情星妈课堂海报
import {drawPoster} from "@/components/poster/posterjs/painter.js"; //疫情星妈课堂海报
import foodVedio from "./component/video.vue"; //京城视频
import * as until from "@/assets/js/common.js"; //公共方法
import {fomatterNum, getCookie, is_weixin, isUserLogin, useModelTime} from "@/assets/js/common.js";
import goBack from "@/components/common/goBack"; //返回组件
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import bjDoctorData from "./../../../utils/mockData/bjDoctor"; //名医数据
// import loginTip from "@/views/contents/calendar/component/logintip"; //注册提示组件
import loginTip from '@/components/registerPop.vue' //注册提示组件
import API from "@/utils/axiosApi/catipaldoctorApi"; //api
import {Toast} from "vant";
import { BuiedPointClick_Fn, xmhh5JcmyVideoView } from '@/assets/js/BuriedPointEvent.js'
import { commonOperationEvent } from '@/utils/commonApiList'


const {interVal, clearTime} = useModelTime();
export default {
  name: "bjDoctor",
  components: {
    foodVedio,
    goBack,
    mySwiper,
    loginTip,
    canvasPoster,
  },
  props: [],
  data() {
    return {
      categoryLabels: [],
      checkLogin: false, //跳转登录弹框
      playStatus: false,
      foodPause: require("@assets/images/food/food_pause.png"),
      foodPlay: require("@assets/images/bjDoctor/play.png"),
      showVedio: false,
      jumpIds: [], //滚动id
      dataInfo: {},
      //视频信息
      bjDoctorData: bjDoctorData,
      dataList: null, //列表数据
      bottomText: "",
      // 分页参数
      pageParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false, //是否加载
        finished: false, //到底提示
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      jumpId: "", //首页跳转过来的分类
      playIndex: 0,
      dataAll: [], //列表所有数据
      doctorIndex: 0, //当前医生下标
      showBack: true,
      isDiamonds: false,
      painting: {},
      src: "",
      select: "全部", //月龄选项
      active: -1, //激活月龄选项
      flag: false, //控制月龄标签选项显示隐藏
      optionList: [], //月龄数据
      periodid: "0", //当前月龄id
      typeId: "0", //当前tab id
      classificationActive: 0, //当前选中的分类
      PromotionalVideo: {}, //宣传视频信息
      Masterrule: {
        "1": "goidIntegral",
        "31": "platinumIntegral",
        "35": "diamondIntegral",
      },
    };
  },
  computed: {
    // 判断是否来自小程序环境
    checkFromMiniprogram() {
      return until.isFromMiniprogram(this.$route);
    },
    isGoLogin() {
      return until.isUserLogin();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      sessionStorage.setItem("pre", from.path);
      if (vm.is_weixin()) {
        if (
            vm.getCookie("xmh_openid") == null ||
            vm.getCookie("xmh_openid") == ""
        ) {
          //判断有没有openId
          location.href =
              "/xmh/v2/wechat/oauth2/authorize?url=" +
              encodeURIComponent(window.location.href);
        } else {
        }
      }
      // 缓存页面
      vm.$store.commit("changeIncludes", ["bjDoctor"]);
    });
  },
  watch: {},
  created() {
  },
  mounted() {
    sessionStorage.removeItem("isDoctorDetail"); //每次进入页面清除
    this.initPage();
    this.jumpId = this.$route.params.tojump;
    this.showBack =
        this.$route.query.crmId || this.$route.query.crmId == "" ? false : true;
    var shareDataParams = {
      shareLink: location.href.split("#")[0],
      shareDesc:
          "知名三甲医院主任级专家，科普育儿难题，星妈会带您轻松带娃，精致当妈！",
      shareTitle: "京城名医",
      imgUrl: "https://image-mom.feihe.com/wxshare/jingchengmingyi.jpg", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
  methods: {
    interVal,
    clearTime,
    is_weixin,
    fomatterNum,
    getCookie,
    drawPoster,
    getmotherState: until.getmotherState,
    // 滚动tab点击
    onClickTab() {
      this.typeId = this.categoryLabels[this.classificationActive].id;
      this.getDoctorList();
      sensors.track("Category_Click", {
        Classification_content: this.categoryLabels[this.classificationActive]
            .name,
        Click_location: "京城名医主页",
      });
    },
    initPage() {
      if (
          isUserLogin() &&
          (this.$route.query.crmId || this.$route.query.sign)
      ) {
        // this.$router.push({
        //   path: "/phoneLogin?redirect=" + window.location.href,
        // });
        until.globalGoLogin()
      } else {
        this.addQrcodeNum(); //扫码增加分享量
        this.scanFree(); //扫码免费看
      }
      this.getJcDocVideoInfo(); //宣传视频
      API.getAllClass({}, (res) => {
        this.categoryLabels = res.data;
        this.categoryLabels.unshift({id: 0, name: "全部"});
        // 首页跳转进来选中分类
        if (this.$route.query.typeId) {
          const index = this.categoryLabels.findIndex((item) => {
            return item.id == this.$route.query.typeId;
          });
          this.classificationActive = index;
          this.typeId = this.$route.query.typeId;
        }
        this.getMonthsPeriod();
      });
    },
    // 获取月龄段
    getMonthsPeriod(select, id) {
      this.$http.get("/babyWikiRevision/monthsPeriod", {}, (res) => {
        if (res.code == 200) {
          this.optionList = [{name: "全部", id: 0}];
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].id > 0 && res.data[i].id < 7) {
              this.optionList.push(res.data[i]);
            }
          }
          var babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
          if (babyInfo) {
            let currentBaby = localStorage.getItem("babyNums");
            let babyIndex = babyInfo.findIndex((item, index) => {
              return item.num == currentBaby;
            });
            console.log(babyInfo[babyIndex]);
            this.active = this.periodid =
                babyInfo[babyIndex !== -1 ? babyIndex : 0].tag_id;
            this.select = this.optionList[this.active].name;
            this.periodid = this.optionList[this.active].id;
          } else {
            this.active = this.periodid = "0";
            this.select = "全部";
          }
          // 登录成功返回请求全部数据
          if (sessionStorage.getItem("bjDoctorLoginJumpVideoId")) {
            this.typeId = this.periodid = this.classificationActive = this.active = 0;
            this.select = this.optionList[this.active].name;
          }

          this.getDoctorList(this.$route.params.tojump, this.jumpScroll);
        }
      });
    },
    // 选择月龄标签
    showHander(e) {
      this.flag = !this.flag;
      if (this.flag) {
        $(".selector-down").slideDown();
        $(".search-class").fadeOut(100);
      } else {
        $(".selector-down").slideUp();
      }
      for (var i = 0; i < this.optionList.length; i++) {
        if (this.select == this.optionList[i].name) {
          this.active = i;
        }
      }
    },
    //点击月龄选项
    seletHander(option, id) {
      this.flag = !this.flag;
      this.select = option;
      $(".selector-down").slideUp();
      if (this.periodid == id) return false;
      this.periodid = id;
      this.getDoctorList();
    },
    // 切换上一个
    switchoverVideoPrev(id) {
      let index = this.dataAll.findIndex((item) => {
        return item.id === id;
      });
      if (index <= 0) {
        Toast("已是最新内容");
      } else {
        this.getDoctorDetail(this.dataAll[index - 1]);
        // this.dataInfo = this.dataAll[index - 1];
      }
    },
    // 切换下一个
    switchoverVideoNext(id) {
      let index = this.dataAll.findIndex((item) => {
        return item.id === id;
      });
      console.log(index, this.dataAll.length - 1);
      if (index >= this.dataAll.length - 1) {
        Toast("暂无更多内容");
      } else {
        this.getDoctorDetail(this.dataAll[index + 1]);
        // this.dataInfo = this.dataAll[index + 1];
      }
    },
    // 星妈课堂疫情
    posterSaveStart: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
    },
    posterSaveEnd: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
    },
    // doctorShare(weekCourse, name) {
    //   console.log(weekCourse);

    //   if (this.isGoLogin) {
    //     // this.$router.push({
    //     //   path: "/phoneLogin?redirect=" + window.location.href,
    //     // });
    //     until.globalGoLogin()
    //   } else {
    //     if (
    //         this.getCookie("xmh_openid") == null ||
    //         this.getCookie("xmh_openid") == ""
    //     ) {
    //       location.href =
    //           "/xmh/v2/wechat/oauth2/authorize?url=" +
    //           encodeURIComponent(window.location.href);
    //     } else {
    //       $(".canvasposter").css("display", "block");
    //       this.posterMsg = weekCourse;
    //       this.posterMsg.title = weekCourse.name;
    //       this.posterMsg.crmId = btoa(until.getUserInfo());
    //       this.posterMsg.sign = this.$route.query.sign
    //           ? this.$route.query.sign
    //           : "0";
    //       const params = {
    //         type: "doctor", // 尝试换一下base,image
    //       };
    //       this.drawPoster(params, this.posterMsg).then((res) => {
    //         console.log(res);
    //         this.painting = res;
    //       });
    //       sensors.track("JCMY_share", {
    //         Share_button_location: "列表分享",
    //         content_title: weekCourse.name,
    //       });
    //     }
    //   }
    // },
    // 星妈课堂疫情海报保存
    success(src) {
      console.log(src, 'canvas')
      this.src = src;
    },
    fail(err) {
      console.log("fail", err);
    },
    // 登陆扫码
    scanFree() {
      API.scanFree(
          {},
          {crmId: until.getUserInfo(), sign: this.$route.query.sign || "0"},
          (res) => {
            if (res.code === "200") {
              switch (res.data.code) {
                case 2000: //扫码成功
                  this.isDiamonds = true;
                  break;
                case 2001: //首页登陆已经扫码
                  this.isDiamonds = true;
                  break;
                case 2002: //首页登陆未扫码
                  this.isDiamonds = false;
                  break;
                case 4040: //该账号已有绑定关系
                  this.isDiamonds = true;
                  break;
                case 4041: //该链接已经被使用
                  this.isDiamonds = false;
                  break;
                case 4042: //该链接已失效
                  this.isDiamonds = false;
                  break;
              }
              this.toastPopup(res.data.code);
            } else if (res.code === "500") {
              this.toastPopup(500);
            }
          }
      );
    },
    toastPopup(code) {
      if (!sessionStorage.getItem("isToast")) {
        sessionStorage.setItem(
            "isToast",
            JSON.stringify({
              // 2000:{state:true,msg:'扫码成功'},
              // 2001:{state:true,msg:'首页已经扫码'},
              // 2002:{state:true,msg:'首页登录未扫码'},
              4040: {
                state: true,
                msg:
                    "绑定失败，您已享受专属VIP权益。本卡仍有效，其他用户可继续绑定",
              },
              4041: {state: true, msg: "绑定失败，该VIP卡已被使用"},
              4042: {state: true, msg: "链接已失效"},
              // 500:{state:true,msg:'扫码失败'},
            })
        );
      }
      let toastState = JSON.parse(sessionStorage.getItem("isToast"));
      if (toastState[code].state) {
        this.$toast({
          message: toastState[code].msg,
          forbidClick: true,
          duration: code === 4040 ? 3000 : 2000,
          context: this,
        });
        toastState[code].state = false;
        sessionStorage.setItem("isToast", JSON.stringify(toastState));
      }
    },
    // 返回
    goBack() {
      if (sessionStorage.getItem("pre") == "/") {
        this.$router.push("/expertsView");
      } else {
        this.$router.go(-1);
      }
    },
    slideChange(index) {
      this.doctorIndex = index;
    },
    // 医生轮播跳转详情
    doctorDetail(item) {
      sensors.track("Expert_Click", {
        expert: item.name,
      });
      this.getDoctorDetail({id: item.id});
    },
    // 获取列表数据
    getDoctorList(id, callBack) {
      API.dcotorCollectLst(
          {},
          {typeId: this.typeId, ageId: this.periodid},
          (res) => {
            if (res.code == 200) {
              this.dataList = res.data;
              this.dataAll = JSON.parse(JSON.stringify(this.dataList));
              if (this.PromotionalVideo.name)
                this.dataAll.unshift(this.PromotionalVideo);
              console.log(this.dataAll);
              this.pageParams.loading = false; //加载状态取消

              this.pageParams.finished = true;
              this.bottomText = "——已经到底了哦——";
              // 判断是否是在视频10秒登录返回的 续播
              this.$nextTick(() => {
                xmhh5JcmyVideoView.observe('xmhh5_jcmy_video_view', '.doctor-info')
                if (sessionStorage.getItem("bjDoctorLoginJumpVideoId")) {
                  let index = this.dataAll.findIndex((item) => {
                    return (
                        item.id ==
                        sessionStorage.getItem("bjDoctorLoginJumpVideoId")
                    );
                  });
                  this.getDoctorDetail(this.dataAll[index]);
                  sessionStorage.removeItem("bjDoctorLoginJumpVideoId");
                  setTimeout(() => {
                    this.$refs.childVideo.Player.currentTime = 9;
                  }, 500);
                }
              });
            }
          }
      );
    },
    //滚动函数
    jumpScroll(id) {
      this.$nextTick(() => {
        if (this.$route.params.tojump && this.dataInfo) {
          window.scrollTo(0, document.getElementById(id).offsetTop);
        }
      });
    },
    // 跳转京城名医详情
    jumpBjdoctor(item) {
      console.log(item);
      this.getDoctorDetail(item);
      sessionStorage.setItem("isDoctorDetail", "open"); //进入播放设置
      this.clearTime(); //停止全局定时器
    },
    // 获取详情
    getDoctorDetail(item) {
      let newItem = JSON.parse(JSON.stringify(item));
      var isPromotional; //是否是宣传视频
      const {code} = this.getmotherState();
      // 判断是宣传视频给个标识并且更换id
      if (newItem.id === "999") {
        newItem.id = this.promotionalId;
        isPromotional = true;
      }
      console.log(this.dataAll);
      API.catipalDcotorDetailNew(
          {},
          {id: newItem.id, crmId: until.getUserInfo(), memberLevelCode: code},
          (res) => {
            if (res.code === 200) {
              if (!res.data) {
                this.$toast("课程已下架");
                this.getDoctorList();
                return false;
              }
              if (isPromotional) {
                res.data.isPromotional = true;
              }
              this.dataInfo = res.data;
              this.playVedio();
              BuiedPointClick_Fn('xmhh5_jcmy_video_click', {xmhh5_jcmy_video_name: res.data.name})
              commonOperationEvent({
                itemId: newItem.id,
                crmId: until.getUserInfo(),
                type: 0,
                columnIds: ['5'],
                actionType: 4,
                contentType: 3
              })
            }
          }
      );
    },
    playVedio() {
      // this.dataInfo = this.PromotionalVideo
      this.clearTime(); //第二天清除时间
      this.playStatus = !this.playStatus;
      if (this.playStatus) {
        this.showVedio = true;

        // this.$refs.childVideo.initPlayer();
      }

      console.log(this.playStatus);
      console.log("播放");
    },
    // 第二天清除时间
    clearTimeNo() {
      const end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      ).getTime(); //存一下当天23：59：59秒
      const start = new Date().getTime(); //现行时间戳
      if (localStorage.getItem("endTime")) {
        if (start > localStorage.getItem("endTime")) {
          localStorage.removeItem("foodCurrentTime");
          localStorage.removeItem("saveFoodGroth"); //清除本地已看视频id 第二天从头播放
          localStorage.setItem("endTime", end);
        }
      } else {
        localStorage.setItem("endTime", end);
      }
    },
    // 视频播放返回按钮
    hidevedioEvent() {
      sessionStorage.setItem("isDoctorDetail", "close"); //退出播放器设置退出状态
      this.interVal(); //打开全局注册计时器
      this.showVedio = false;
      this.playStatus = false;
    },
    // 播放埋点
    playerBuriedpoint({num, total, percent, id}) {
      this.playIndex++;
      console.log(this.dataAll, id);
      let index = this.dataAll.findIndex((item) => {
        return item.id === id;
      });
      if (this.playIndex == 1) {
        sensors.track("Audio_and_video_playback", {
          content_id: this.dataInfo.id,
          content_title: this.dataInfo.name,
          length_of_time: total,
          position: index,
          content_topic: "宣传片",
          Membership_level: this.getmotherState().name,
          video_duration: num,
          is_finished: percent >= 0.8 ? true : false,
          Content_column: "京城名医",
        });
      }
    },
    isUserLogin() {
      if (isUserLogin()) {
        this.$refs.childVideo.Player.pause();
        this.checkLogin = true;
      }
    },
    // 确认
    confirmWay() {
      this.checkLogin = false;
      this.$refs.childVideo.isLogin();
      this.loginRegistSensors("确定");
    },
    // 取消
    cancleWay() {
      this.$refs.childVideo.Player.pause();
      this.$refs.childVideo.Player.currentTime = 9;
      this.checkLogin = false;
      this.loginRegistSensors("取消");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: "京城名医",
      });
    },
    // 获取宣传视频
    getJcDocVideoInfo() {
      API.getJcDocVideoInfo({}, {}, (res) => {
        if (res.code === "200") {
          res.data.bjDoctor = "bgDoctor";
          this.PromotionalVideo = res.data;
          this.promotionalId = res.data.id;
          this.PromotionalVideo.id = "999"; //宣传视频设置唯一id
        }
      });
    },
    // 二维码分享活动扫码量增加
    addQrcodeNum() {
      let queryInfo = this.$route.query;
      // 判断是否是分享二维码进来的
      if (queryInfo.id && queryInfo.crmId && queryInfo.title) {
        this.active = 0;
        this.select = "全部";
        this.$http.post(
            "/starMom/getUser",
            {},
            {crmId: atob(queryInfo.crmId)},
            (res) => {
              if (res.code === "200") {
                // open_id是否存在
                let isCancel = res.data.memberChannel.some((item, index) => {
                  return item.account_type === "open_id";
                });
                // 判断二维码分享者是否处于注销状态 isCancel为true并且mobile存在 未注销状态
                if (isCancel && res.data.mobile && res.data.mobile.length > 0) {
                  // 分享二维码进入请求
                  const {id: capitalId, crmId} = this.$route.query;
                  API.addQrcode({}, {capitalId, crmId: atob(crmId)}, (res) => {
                    if (res.code == "200") {
                      sensors.track("Code_scanning_times", {
                        content_title: queryInfo.title,
                      });
                    }
                  });
                }
              }
            }
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./less/index.less";
</style>
